import React from 'react'
import RestrictionPopup from '../components/RestrictionPopup/RestrictionPopup'

export default function RestrictionProvider({ children }) {
    return <>
        <RestrictionPopup />
        {children}
    </>
}
